import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

export const editLinkPluginModalSchema = (t: TFunction<Namespace<'en'>>) =>
  Yup.object({
    text: Yup.string().required(),
    url: Yup.string()
      .matches(
        // The combined regex we created
        /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/[a-zA-Z0-9]+\.[^\s]{2,}|[a-zA-Z0-9]+\.[^\s]{2,})|(\[\$[^$]*\$\])$/i,
        t('form.editor.link.urlValidationMessage'),
      )
      .required(),
    openInNewWindow: Yup.boolean().optional(),
  });

export type EditLinkPluginModalFormValues = Yup.InferType<
  ReturnType<typeof editLinkPluginModalSchema>
>;
